import { useState, useEffect, useLayoutEffect } from "react"
import { PROGRAM_DETAILS_MODE, PROGRAM_ORIGIN } from "scenes/components/EpgChannelDetailsInfo"
import IconButton from "@mui/material/IconButton"
import { LightTooltip } from "components/LightTooltip"
import { DiscoverCarousel } from "./DiscoverCarousel"
import { CreateComponent } from "components/utils/CreateComponent"
import { GenreTile } from "./GenreTile"
import { rootStore } from "store/RootStore"
import { analyticsMeta } from "store/qlapi/LogService"
import { l10n } from "store/lang/L10n"

import "scenes/Overlay/OverlayEventDetails.css"
import "scenes/LiveTv/components/slideRelatedContent.css"
import "./Discover.css"
import "./CategorieButtons.css"

export const DiscoverCategoryComponent = CreateComponent(null, false, true, ({ page, origin }) => {
	const [containerWidth, setContainerWidth] = useState("100%")
	const [containerBorder, setContainerBorder] = useState(0)
	const [renderFirstPartOnly, setRenderFirstPartOnly] = useState(true)
	const { minmax, setMinMax } = useState(20)

	function handleResize() {
		//const componentWidth = document.getElementById("discoverCategoryComponent")?.getBoundingClientRect()?.width
		const componentWidth = page.modalWidth
		if (componentWidth && page.sectionTitleMarginLeft[origin]) {
			//const containerBorder = componentWidth > 1024 ? 80 : componentWidth > 512 ? 40 : 16
			const containerBorder = page.sectionTitleMarginLeft[origin]
			setContainerBorder(containerBorder)
			const containerWidth = componentWidth
			setContainerWidth(containerWidth - 2 * containerBorder)
		}
		//console.debug("handleResize DiscoverCategoryComponent", containerWidth)
	}

	const [selectedChild, setSelectedChild] = useState(null)
	const [selectedTopCategory, setSelectedTopCategory] = useState(null)

	useEffect(() => {
		handleResize()
		setTimeout(() => {
			setRenderFirstPartOnly(false)
		}, 300)
		// no event listener, resizing is done via observable page.modalWidth / modalHeight
		return (() => {
		})
	}, [])

	useEffect(() => {
		//console.debug("useEffect", page.discoverCategory, page.discoverCategory.topCategory)
		setSelectedTopCategory(page.discoverCategory?.topCategory)
		return (() => {
		})
	}, [page.discoverCategory?.topCategory])

	useEffect(() => {
		handleResize()
		return (() => {
		})
	}, [page.modalWidth, page.modalHeight, page.sectionTitleMarginLeft[origin]])

	useLayoutEffect(() => {
		const selectedId = page.discoverCategory?.selected?.id
		const selectedChild = page.discoverCategory?.children?.contents?.filter(item => {
			return item.id === selectedId
		})
		// MTVW-965: moved to clickHandler below
		//rootStore.logService.analyticsDiscoverCategoryTap({ [analyticsMeta.subCat]: selectedId })
		//console.debug("selectedChild %o, length %s, selected %o, top %o, page", selectedChild, selectedChild.length, page.discoverCategory?.selected, page.discoverCategory?.topCategory, page)
		if (selectedChild.length > 0) setSelectedChild(selectedChild)
	}, [page.discoverCategory?.selected])

	const closeButtonOverlay = <div className="closeLayer">
		<LightTooltip title={l10n.featureTooltipClose} placement="bottom">
			<IconButton aria-label="Close"
				id="closeOverlay"
				disableRipple={true}
				disableFocusRipple={true}
				className="closeButton" onClick={(event) => {
					event.preventDefault()
					event.stopPropagation()
					// MTVW-624: combined activityStack for related content and search
					//page.resetActivity()
					page.setShow(false)
					//page.setIsPlayerPresent(false)
				}} data-test="overlay_close">
			</IconButton>
		</LightTooltip>
	</div>

	const clickHandler = (item) => {
		rootStore.logService.analyticsDiscoverCategoryTap({ [analyticsMeta.subCat]: item?.id })
		//console.debug("discoverCategoryTap", item?.id)
		page.setDiscoverCategory({ topCategory: page.discoverCategory?.topCategory, selected: item, children: page.discoverCategory?.children }).setShow(true/*, CALLING_CONTEXT_TYPE.Search*/)
	}

	const classRelatedContentAnimation = selectedChild?.[0]?.items?.length > 0 ?
		selectedChild?.[0]?.items?.length <= 3 ? "slideRelatedContent slideRelatedContentHalf" : "slideRelatedContent slideRelatedContentFull"
		: ""
	//console.debug("classRelatedContentAnimation", classRelatedContentAnimation, selectedChild?.[0]?.items?.length)

	return (
		<div id="discoverCategoryComponent" className="DiscoverBody">
			<div className="HeroFrame">
				{page.discoverCategory?.children?.heroes?.length > 0 && <DiscoverCarousel page={page} variant={"hero"} contentArray={page.discoverCategory.children.heroes} origin={PROGRAM_ORIGIN.overlay} />}
			</div>
			{closeButtonOverlay}
			{/*<div className="categoriesPadding" />*/}
			{/* minHeight: "110vh": avoid jump in page when selecting a category that has less tiles */}
			{/* MTVW-933, finding 5: delayed display*/}
			<div className="CategoryLane" style={{ visibility: renderFirstPartOnly ? "hidden" : "visible", minHeight: "110vh", paddingBottom: 24 }}>
				<div className="CategoryTitle" style={{ marginLeft: containerBorder }}>
					{selectedTopCategory?.displayText}
				</div>
				<DiscoverCarousel variant={"catButton"} page={page} lane={null} contentArray={page.discoverCategory?.children?.categories} origin={PROGRAM_ORIGIN.overlay} clickHandler={clickHandler} />
				<div className="categoriesPadding" style={{ paddingTop: 40 }}></div>
				<div /*className={`${classRelatedContentAnimation}`}*/ style={{ width: containerWidth, marginLeft: containerBorder, marginRight: containerBorder }}>
					<div className="CategoryGridList" >
						{selectedChild?.[0]?.items?.map((item, ix) => (
							<GenreTile key={"ca_T" + ix} variant={"category"} isDragging={false} page={page} oEventData={null} item={item} ix={ix} nbItems={selectedChild[0]?.items.length} origin={PROGRAM_ORIGIN.overlay} /*origin={origin} resetOverlay={resetOverlay}*/ />
						))}
					</div>
				</div>
			</div>
		</div>
	)
})
